import React, { memo, forwardRef } from "react";
const SvgMatrix3X3 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={64}
      height={32}
      fill="none"
      viewBox="0 0 64 32"
      ref={svgRef}
      {...props}
    >
      <rect width={6} height={6} x={21} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={29} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={37} y={5} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={21} y={13} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={29} y={13} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={37} y={13} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={21} y={21} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={29} y={21} fill="#DBDBDB" rx={1} />
      <rect width={6} height={6} x={37} y={21} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        d="M18.29 29h-2.367c-.615 0-.923-.322-.923-.966V3.966c0-.644.308-.966.923-.966h2.367c.473 0 .71.223.71.669 0 .446-.237.669-.71.669h-1.728v23.324h1.728c.473 0 .71.223.71.67 0 .445-.237.668-.71.668zM45.71 29h2.367c.615 0 .923-.322.923-.966V3.966c0-.644-.308-.966-.923-.966H45.71c-.473 0-.71.223-.71.669 0 .446.237.669.71.669h1.728v23.324H45.71c-.473 0-.71.223-.71.67 0 .445.237.668.71.668z"
      />
    </svg>
  );
});
SvgMatrix3X3.displayName = "SvgMatrix3X3";
const MemoForwardRef = memo(SvgMatrix3X3);
export default MemoForwardRef;
